import { Button } from '@sleepstation/components'
import { HList } from '@sleepstation/components-layouts'
import { SIZE } from '@sleepstation/const'
import {
  baseline,
  marginLeft,
  mq,
  padding,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div.attrs({ 'data-cy': `account-nav` })`
  ${mq(`xSmallOnly`)} {
    ul {
      > * + * {
        ${marginLeft(0.25)}
      }
    }
  }

  a {
    min-width: auto;

    ${mq(`xSmallOnly`)} {
      ${padding([[0.5, 0.35]])}
      ${baseline(-1)}
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AccountNav = ({ onLogout, logoutLabel }) => (
  <Layout>
    <HList>
      <Button
        size={SIZE.X_SMALL}
        kind="secondary"
        onClick={onLogout}
        dataCy="logout-button"
      >
        {logoutLabel}
      </Button>
    </HList>
  </Layout>
)

AccountNav.propTypes = {
  onLogout: PropTypes.func.isRequired,
  logoutLabel: PropTypes.string.isRequired,
}

export default AccountNav
